const NoAccess = (props) => {
	return (
		<div 
			style={{height:'92vh', background:'white', display:'flex', justifyContent:'center', alignItems:'center', color: "gray", fontSize: "20px"}}
		><p>You dont have Permission to Access</p></div>
	)
};


export default NoAccess;
